import PropTypes from 'prop-types';

const ArrowSquareRightSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 24}`}
      height={`${height || 24}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        fill={color}
      />
      <path
        d="M10.7399 16.28C10.5499 16.28 10.3599 16.21 10.2099 16.06C9.91993 15.77 9.91993 15.29 10.2099 15L13.2099 12L10.2099 8.99997C9.91993 8.70997 9.91993 8.22997 10.2099 7.93997C10.4999 7.64997 10.9799 7.64997 11.2699 7.93997L14.7999 11.47C15.0899 11.76 15.0899 12.24 14.7999 12.53L11.2699 16.06C11.1199 16.21 10.9299 16.28 10.7399 16.28Z"
        fill={color}
      />
    </svg>
  );
};

ArrowSquareRightSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArrowSquareRightSvg;
